module.exports = __webpack_public_path__ + "img/22.8cff7096.png";